<template>
  <div>
    <v-layout
      align-center
      justify-center
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-card
          width="100%"
          max-width="800px"
          elevation="24"
        >
          <v-toolbar
            flat
            color="primary-color"
          >
            <v-toolbar-title>
              Redefinir senha de eleitor
            </v-toolbar-title>
            <v-spacer />
            <v-tooltip right>
              <template />
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-form
              ref="frmPRR"
            >
              <v-text-field
                v-model="email"
                label="E-mail"
                placeholder="Informe o seu e-mail"
                :rules="requiredRules"
                required
              />
              <v-card
                max-width="350px"
                elevation="0"
              >
                <ValidateRecaptcha ref="validateR" />
              </v-card>
              <v-expand-transition>
                <v-alert
                  class="mt-5"
                  v-show="alert.show"
                  elevation="2"
                  :type="alert.typeAlert.value"
                >
                  {{alert.value}}
                </v-alert>
              </v-expand-transition>
            </v-form>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="btnRequest"
              :loading="btnLoading"
              :disabled="btnLoading"
              outlined
            >
              Solicitar
            </v-btn>
            <v-btn
              color="error"
              @click="returnElection"
              :disabled="btnLoading"
              outlined
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-layout>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import ValidateRecaptcha from '@/components/security/ValidateRecaptcha';
export default {
  components: {
    ValidateRecaptcha
  },
  data: () => ({
    email: '',
    requiredRules: [v => !!v || 'Campo obrigatório'],
    alert: {
      value: '',
      show: false,
      message: {
        error: 'Houve algum problema na solicitação de alteração de senha.',
        sucess: 'Solicitação enviada.',
        warning: 'Não foi possível identificar o eleitor ou e-mail cadastrado. Verifique os dados inseridos e tente novamente. Caso o erro persista, procure a Comissão Eleitoral.',
        none: ''
      },
      typeAlert: {
        value: 'info',
        type: {
          error: 'error',
          success: 'success',
          warning: 'warning',
          none: 'info'
        }
      }
    },
    btnLoading: false
  }),
  watch: {
    'alert.typeAlert.value': function(value) {
      switch (value) {
        case this.alert.typeAlert.type.error:
          this.alert.value = this.alert.message.error;
          this.alert.show = true;
          break;
        case this.alert.typeAlert.type.success:
          this.alert.value = this.alert.message.sucess;
          this.alert.show = true;
          break;
        case this.alert.typeAlert.type.warning:
          this.alert.value = this.alert.message.warning;
          this.alert.show = true;
          break;
        default:
          this.alert.value = this.alert.message.none;
          this.alert.show = false;
          break;
      }
    }
  },
  mounted() {
    this.$refs.validateR.load(true);
    this.alert.typeAlert.value = this.alert.typeAlert.type.none;
  },
  methods: {
    ...mapActions('voter', { resetPassword: 'sendPasswordReset' }),
    async btnRequest() {
      this.alert.typeAlert.value = this.alert.typeAlert.type.none;
      if (this.$refs.frmPRR.validate()) {
        let params = {};
        const bVerifyRecaptcha = await this.$refs.validateR.verifyRecaptcha();
        const jsonRecaptcha = this.$refs.validateR.getRecaptcha();
        if (bVerifyRecaptcha) {
          params.email = this.email;
          params = Object.assign({}, params, jsonRecaptcha);
          try {
            this.btnLoading = true;
            await this.resetPassword(params);
            const result = this.$store.state.voter.resultPasswordResetRequest;
            if (result.status === 'ok') {
              this.alert.typeAlert.value = this.alert.typeAlert.type.success;
            } else {
              this.alert.typeAlert.value = this.alert.typeAlert.type.warning;
            }
          } catch (error) {
            this.alert.typeAlert.value = this.alert.typeAlert.type.error;
          } finally {
            this.$refs.validateR.resetRecaptcha();
            this.btnLoading = false;
          }
        }
      }
    },
    returnElection() {
      this.$router.push({ name: 'Election' });
    }
  }
};
</script>
